var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { getMyAgencies, getPendingJoinRequests, handleJoinRequest, updateAgencyName, } from "../actions/agencies";
import { getUserData, updateUserData } from "../actions/users";
import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/24/outline";
import { showToast } from "../utils/toastUtils";
import ConfirmModal from "../components/modals/ConfirmModal";
import NotificationPreferencesPanel from "../components/settings/NotificationPreferences";
import SettingsTabs from "../components/settings/SettingsTabs";
import ProfileSettings from "../components/settings/ProfileSettings";
import AgencySettings from "../components/settings/AgencySettings";
import AudioSettings from "../components/settings/AudioSettings";
import WhatsAppSettings from "../components/settings/WhatsAppSettings";
function formatWhatsappNumber(number) {
    if (!number)
        return "";
    var digits = number.replace(/\D/g, "");
    if (digits.length === 13 && digits.startsWith("55")) {
        return "(".concat(digits.slice(2, 4), ") ").concat(digits.slice(4, 5)).concat(digits.slice(5, 9), "-").concat(digits.slice(9, 13));
    }
    if (digits.length === 12 && digits.startsWith("55")) {
        return "(".concat(digits.slice(2, 4), ") ").concat(digits.slice(4, 8), "-").concat(digits.slice(8, 12));
    }
    return number;
}
function formatWhatsappInput(value) {
    var digits = value.replace(/\D/g, "");
    if (!digits)
        return "";
    if (digits.length <= 2)
        return "(".concat(digits);
    if (digits.length <= 7)
        return "(".concat(digits.slice(0, 2), ") ").concat(digits.slice(2));
    if (digits.length <= 11)
        return "(".concat(digits.slice(0, 2), ") ").concat(digits.slice(2, 7), "-").concat(digits.slice(7));
    return "(".concat(digits.slice(0, 2), ") ").concat(digits.slice(2, 7), "-").concat(digits.slice(7, 11));
}
function validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}
function validateWhatsapp(whatsapp) {
    var digits = whatsapp.replace(/\D/g, "");
    return digits.length === 11;
}
var Settings = function () {
    var _a = useState(null), user = _a[0], setUser = _a[1];
    var _b = useState(null), agency = _b[0], setAgency = _b[1];
    var _c = useState([]), joinRequests = _c[0], setJoinRequests = _c[1];
    var _d = useState(true), loading = _d[0], setLoading = _d[1];
    var _e = useState(false), copied = _e[0], setCopied = _e[1];
    var _f = useState(null), editUser = _f[0], setEditUser = _f[1];
    var _g = useState(false), isDirty = _g[0], setIsDirty = _g[1];
    var _h = useState(agency), editAgency = _h[0], setEditAgency = _h[1];
    var _j = useState(false), agencyDirty = _j[0], setAgencyDirty = _j[1];
    var _k = useState(false), modalOpen = _k[0], setModalOpen = _k[1];
    var _l = useState(""), modalTitle = _l[0], setModalTitle = _l[1];
    var _m = useState(""), modalDescription = _m[0], setModalDescription = _m[1];
    var _o = useState(false), modalLoading = _o[0], setModalLoading = _o[1];
    var _p = useState(function () { return function () { }; }), pendingAction = _p[0], setPendingAction = _p[1];
    // ✅ Ler parâmetros da URL
    var searchParams = useSearchParams()[0];
    // ✅ Estado da aba ativa (inicializa com base na URL)
    var _q = useState(function () {
        var tab = searchParams.get('tab');
        return tab || 'profile'; // Default: profile
    }), activeTab = _q[0], setActiveTab = _q[1];
    var _r = useState(5), pollingCountdown = _r[0], setPollingCountdown = _r[1];
    useEffect(function () {
        var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var userRes_1, agencies, foundAgency_1, requests, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 7, 8, 9]);
                        return [4 /*yield*/, getUserData()];
                    case 1:
                        userRes_1 = _c.sent();
                        setUser(userRes_1.data);
                        if (!userRes_1.data.agency) return [3 /*break*/, 6];
                        return [4 /*yield*/, getMyAgencies()];
                    case 2:
                        agencies = _c.sent();
                        foundAgency_1 = agencies.find(function (a) { return String(a.id) === String(userRes_1.data.agency); });
                        setAgency(foundAgency_1 || null);
                        if (!(foundAgency_1 && foundAgency_1.owner === userRes_1.data.id)) return [3 /*break*/, 6];
                        _c.label = 3;
                    case 3:
                        _c.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, getPendingJoinRequests()];
                    case 4:
                        requests = _c.sent();
                        setJoinRequests(requests.filter(function (r) { return r.agency === foundAgency_1.id; }));
                        return [3 /*break*/, 6];
                    case 5:
                        _a = _c.sent();
                        setJoinRequests([]);
                        return [3 /*break*/, 6];
                    case 6: return [3 /*break*/, 9];
                    case 7:
                        _b = _c.sent();
                        setUser(null);
                        setAgency(null);
                        setJoinRequests([]);
                        return [3 /*break*/, 9];
                    case 8:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 9: return [2 /*return*/];
                }
            });
        }); };
        fetchData();
    }, []);
    // ✅ Sincroniza aba com URL quando muda
    useEffect(function () {
        var tab = searchParams.get('tab');
        if (tab && ['profile', 'agency', 'audio', 'whatsapp', 'notifications'].includes(tab)) {
            setActiveTab(tab);
        }
    }, [searchParams]);
    useEffect(function () {
        if (user)
            setEditUser(user);
    }, [user]);
    useEffect(function () {
        setEditAgency(agency);
    }, [agency]);
    var handleRequestAction = function (requestId, action) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, handleJoinRequest(requestId, action)];
                case 1:
                    _a.sent();
                    setJoinRequests(function (prev) { return prev.filter(function (r) { return r.id !== requestId; }); });
                    if (action === "approve") {
                        showToast("success", "Solicitação aprovada com sucesso!");
                    }
                    else {
                        showToast("error", "Solicitação rejeitada.");
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleCopy = function () {
        if (!agency)
            return;
        navigator.clipboard.writeText(String(agency.id));
        setCopied(true);
        setTimeout(function () { return setCopied(false); }, 1500);
    };
    var handleInputChange = function (e) {
        var _a = e.target, name = _a.name, value = _a.value;
        setEditUser(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[name] = value, _a)));
        });
        setIsDirty(true);
    };
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    // console.log('1️⃣ Salvando no banco de dados...');
                    // ✅ PASSO 1: Persistir no banco
                    return [4 /*yield*/, updateUserData({
                            first_name: editUser.first_name,
                            email: editUser.email,
                            whatsapp_number: editUser.whatsapp_number ? "55".concat(editUser.whatsapp_number) : null,
                        })];
                case 1:
                    // console.log('1️⃣ Salvando no banco de dados...');
                    // ✅ PASSO 1: Persistir no banco
                    _a.sent();
                    // console.log('✅ Dados persistidos no banco!');
                    // ✅ PASSO 2: Aguardar um pouco (opcional, para garantir)
                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 500); })];
                case 2:
                    // console.log('✅ Dados persistidos no banco!');
                    // ✅ PASSO 2: Aguardar um pouco (opcional, para garantir)
                    _a.sent();
                    return [4 /*yield*/, getUserData()];
                case 3:
                    response = _a.sent();
                    // console.log('✅ Dados recarregados do /me!', response.data);
                    // ✅ PASSO 4: Atualizar estados
                    setUser(response.data);
                    setEditUser(response.data);
                    setIsDirty(false);
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    console.error('❌ Erro ao salvar:', error_1);
                    throw error_1; // Repassa erro para o componente filho mostrar feedback
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleAgencySave = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!editAgency) return [3 /*break*/, 2];
                    return [4 /*yield*/, updateAgencyName(editAgency.id, editAgency.name)];
                case 1:
                    _a.sent();
                    setAgencyDirty(false);
                    showToast("success", "Nome da agência atualizado!");
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var whatsappVisionCockpit = "62998377158";
    var qrValue = "BEGIN:VCARD\nVERSION:3.0\nFN:Vision Cockpit Notifica\u00E7\u00F5es\nTEL;TYPE=CELL:".concat(whatsappVisionCockpit, "\nEND:VCARD");
    var emailValid = validateEmail((editUser === null || editUser === void 0 ? void 0 : editUser.email) || "");
    var whatsappValid = validateWhatsapp((editUser === null || editUser === void 0 ? void 0 : editUser.whatsapp_number) || "");
    // Polling para status do WhatsApp + countdown
    useEffect(function () {
        var shouldPoll = user &&
            user.whatsapp_number !== "55" &&
            !user.whatsapp_notifications_active;
        if (!shouldPoll) {
            setPollingCountdown(5);
            return;
        }
        setPollingCountdown(5);
        // ✅ CONSULTA AO BACKEND A CADA 5 SEGUNDOS
        var pollingInterval = setInterval(function () { return __awaiter(void 0, void 0, void 0, function () {
            var userRes, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setPollingCountdown(0); // ✅ Exibe "verificando..." imediatamente
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, getUserData()];
                    case 2:
                        userRes = _b.sent();
                        // ✅ Atualiza apenas se whatsapp_notifications_active vier true
                        if (userRes.data.whatsapp_notifications_active) {
                            setUser(function (prev) { return (__assign(__assign({}, prev), { whatsapp_notifications_active: true })); });
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 4:
                        // ✅ Após 1 segundo, volta para 4
                        setTimeout(function () {
                            setPollingCountdown(4);
                        }, 1000);
                        return [2 /*return*/];
                }
            });
        }); }, 5000); // ✅ 5 segundos para consulta ao backend
        // ✅ COUNTDOWN VISUAL A CADA 1 SEGUNDO (5 → 4 → 3 → 2 → 1 → 0 "verificando...")
        var countdownInterval = setInterval(function () {
            setPollingCountdown(function (prev) {
                if (prev <= 0)
                    return 0; // Mantém em 0 durante "verificando..."
                return prev - 1;
            });
        }, 1000); // ✅ 1 segundo para countdown visual
        return function () {
            clearInterval(pollingInterval);
            clearInterval(countdownInterval);
        };
    }, [user === null || user === void 0 ? void 0 : user.whatsapp_number, user === null || user === void 0 ? void 0 : user.whatsapp_notifications_active]);
    if (loading)
        return (React.createElement("div", { className: "min-h-[calc(100vh-112px)] flex items-center justify-center bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900" },
            React.createElement("div", { className: "animate-spin rounded-full h-16 w-16 border-b-2 border-cyan-400" })));
    return (React.createElement("div", { className: "min-h-[calc(100vh-112px)] bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 flex flex-col items-center py-12 px-2" },
        React.createElement("div", { className: "w-full max-w-5xl bg-gradient-to-br from-gray-800/90 via-gray-900/80 to-gray-800/90 rounded-3xl shadow-2xl px-2 py-4 md:p-10 flex flex-col gap-8 border border-cyan-700/30" },
            joinRequests.length > 0 && (React.createElement("section", { className: "w-full bg-gradient-to-r from-green-900/60 via-gray-800/80 to-green-900/60 rounded-2xl p-6 shadow-lg border border-green-400/20" },
                React.createElement("h2", { className: "text-2xl font-bold mb-4 text-green-300 flex items-center gap-2" },
                    React.createElement("span", null, "Solicita\u00E7\u00F5es de entrada"),
                    React.createElement("span", { className: "bg-green-500/20 text-green-200 px-3 py-1 rounded-full text-sm font-semibold" }, joinRequests.length)),
                React.createElement("ul", { className: "space-y-4 w-full" }, joinRequests.map(function (req) { return (React.createElement("li", { key: req.id, className: "bg-gray-800/80 rounded-xl p-5 flex flex-col md:flex-row md:justify-between md:items-center gap-4 border border-green-400/10 hover:shadow-xl transition" },
                    React.createElement("span", { className: "text-base text-gray-100" },
                        req.user_name ? (React.createElement(React.Fragment, null,
                            React.createElement("span", { className: "font-bold text-blue-300" }, req.user_name))) : (React.createElement(React.Fragment, null,
                            "Usu\u00E1rio ",
                            React.createElement("span", { className: "font-bold text-blue-300" },
                                "#",
                                req.user))),
                        " solicitou entrada na ",
                        req.agency_name ? (React.createElement("span", { className: "font-bold text-green-300" }, req.agency_name)) : (React.createElement(React.Fragment, null,
                            "ag\u00EAncia ",
                            React.createElement("span", { className: "font-bold text-green-300" },
                                "#",
                                req.agency))),
                        "."),
                    React.createElement("div", { className: "flex gap-2" },
                        React.createElement("button", { className: "flex items-center gap-1 bg-green-600 hover:bg-green-700 px-4 py-2 rounded-lg font-semibold transition text-white shadow-md", onClick: function () { return handleRequestAction(req.id, "approve"); } },
                            React.createElement(CheckCircleIcon, { className: "w-5 h-5" }),
                            "Aprovar"),
                        React.createElement("button", { className: "flex items-center gap-1 bg-green-800 hover:bg-green-900 px-4 py-2 rounded-lg font-semibold transition text-green-200 shadow-md border border-green-400/20", onClick: function () { return handleRequestAction(req.id, "reject"); } },
                            React.createElement(XCircleIcon, { className: "w-5 h-5" }),
                            "Rejeitar")))); })))),
            React.createElement(SettingsTabs, { activeTab: activeTab, onTabChange: setActiveTab }),
            activeTab === 'profile' && editUser && (React.createElement(ProfileSettings, { editUser: editUser, onInputChange: handleInputChange, onSave: handleSave, isDirty: isDirty, emailValid: emailValid, whatsappValid: whatsappValid, formatWhatsappInput: formatWhatsappInput })),
            activeTab === 'agency' && agency && (React.createElement(AgencySettings, { agency: agency, editAgency: editAgency, onNameChange: function (name) {
                    setEditAgency(function (prev) { return prev ? __assign(__assign({}, prev), { name: name }) : prev; });
                    setAgencyDirty(true);
                }, onSave: handleAgencySave, onCopy: handleCopy, isDirty: agencyDirty, copied: copied })),
            activeTab === 'audio' && (React.createElement(AudioSettings, null)),
            activeTab === 'whatsapp' && (React.createElement(WhatsAppSettings, { onInputChange: handleInputChange, onSave: handleSave, whatsappValid: validateWhatsapp, user: user, formatWhatsappNumber: formatWhatsappNumber, editUser: editUser, pollingCountdown: pollingCountdown })),
            activeTab === 'notifications' && (React.createElement("section", { className: "flex flex-col gap-6 w-full bg-gradient-to-r from-orange-900/60 via-gray-800/80 to-orange-900/60 rounded-2xl p-8 shadow-lg border border-orange-400/20" },
                React.createElement(NotificationPreferencesPanel, null)))),
        React.createElement("footer", { className: "mt-10 text-gray-500 text-xs text-center opacity-70" },
            "Vision Cockpit \u00A9 ",
            new Date().getFullYear()),
        React.createElement(ConfirmModal, { open: modalOpen, title: modalTitle, description: modalDescription, onConfirm: pendingAction, onCancel: function () { return setModalOpen(false); }, loading: modalLoading })));
};
export default Settings;
